export default "__VITE_ASSET__C4ITHiF4__"